import { forwardRef, useEffect } from 'react';
import { LiveActivities } from '../../interface/LiveActivities.interface';
import activityBg from '../../../../assets/images/home/speakup-game/game-bg.svg';
import Counter from '../../../../components/Countre/Countre';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCountdown } from '../../../../core/hooks/useCount';

export const Activity = forwardRef<HTMLDivElement, { currentActivity: LiveActivities; refetch: () => {} }>(({ currentActivity, refetch }, ref) => {
	const { t } = useTranslation();

	return (
		<div
			ref={ref}
			style={{ backgroundImage: `url(${activityBg})` }}
			className="flex h-full w-full items-center justify-center bg-cover bg-center px-6 py-6 transition-all duration-200 ease-in-out 2xl:px-16"
		>
			<div className="flex h-full w-full flex-col justify-between">
				<div>
					<div className="flex flex-row items-center gap-3">
						<img
							src={`${process.env.REACT_APP_STORAGE}${currentActivity?.image}`}
							alt={currentActivity?.name}
							className="h-16 w-16 rounded-full object-cover object-center"
						/>
						<div className="flex flex-col">
							<div className=" section-title font-manropeBold text-xl text-white">{currentActivity?.name}</div>
							<div className=" font-manropeMedium text-sm text-gray-200">{currentActivity?.label}</div>
						</div>
					</div>
					<div className="text__default  mt-2 text-justify text-gray-100">
						{currentActivity?.short_description.length > 250
							? currentActivity?.short_description.slice(0, 250) + '...'
							: currentActivity?.short_description}
					</div>
				</div>

				<div className="text__default mt-4 flex items-start justify-between gap-2">
					<Counter targetTime={new Date(currentActivity.end_time).getTime()} refetch={refetch} />
					<Link to={`/rounds/my-activity/${currentActivity?.type}/${currentActivity?.slug}`} className=" text-decoration-none">
						<button className="flex flex-row items-center gap-2 rounded-lg bg-white px-3 py-2.5 text-[#01ABC1] xl:px-6">
							<span className="">{t('Continue')}</span>
							<BsArrowRight />
						</button>
					</Link>
				</div>
			</div>
		</div>
	);
});
